export default function isComputedProperty(name, definitions) {
	return definitions[name] && definitions[name].computed;
}
